module.exports = __webpack_public_path__ + "img/chart-setting-4.691fc776.png";